export default "__VITE_ASSET__BGJbMlch__"